import ModalComponent from '../../../components/ModalComponent';
import TextFieldComponent from '../../../components/TextFieldComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import { Grid2 } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import zod from 'zod';
import { SipClientReasonFormSchema } from '../../../services/SipClientReasonsService/schemas';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  useCreateSipClientReasonAsync,
  useUpdateSipClientReasonAsync,
} from '../../../services/SipClientReasonsService/hooks/useMutation';
import { useContext, useEffect } from 'react';
import { AppContext } from '../../../context/AppContextProvider';
import { ISipClientReasonProps } from '../../../services/SipClientReasonsService/types';

type ReasonEditionFormInput = zod.infer<typeof SipClientReasonFormSchema>;

interface ReasonEditionModalProps {
  onClose: () => void;
  isOpen: boolean;
  reasonSelected?: ISipClientReasonProps;
}

const ReasonEditionModal = ({
  isOpen,
  onClose,
  reasonSelected,
}: ReasonEditionModalProps) => {
  const { control, handleSubmit, reset } = useForm<ReasonEditionFormInput>({
    resolver: zodResolver(SipClientReasonFormSchema),
  });
  const { showSnackbar } = useContext(AppContext);

  const {
    mutateAsync: mutateCreateSipClientReasonAsync,
    isLoading: isLoadingCreateSipClientReasonAsync,
  } = useCreateSipClientReasonAsync();
  const {
    mutateAsync: mutateUpdateSipClientReasonAsync,
    isLoading: isLoadingUpdateSipClientReasonAsync,
  } = useUpdateSipClientReasonAsync();

  const handleSubmitForm = async (data: ReasonEditionFormInput) => {
    if (data.id) {
      await mutateUpdateSipClientReasonAsync(
        { id: data.id, data },
        {
          onSuccess: () => {
            showSnackbar('Justificativa atualizada com sucesso.', 'success');
          },
        },
      );
    } else {
      await mutateCreateSipClientReasonAsync(data, {
        onSuccess: () => {
          showSnackbar('Justificativa cadastrada com sucesso.', 'success');
        },
      });
    }

    onCloseForm();
  };

  const onCloseForm = () => {
    reset();
    onClose();
  };

  useEffect(() => {
    if (reasonSelected && reasonSelected.id)
      reset(reasonSelected, { keepDefaultValues: true });
  }, [reasonSelected]);
  return (
    <ModalComponent
      onClose={onCloseForm}
      isOpen={isOpen}
      title={'Edição de justificativa'}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(handleSubmitForm)();
        }}
      >
        <Controller
          control={control}
          name={'description'}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <TextFieldComponent
              value={value}
              error={!!error}
              errorMessage={error?.message}
              onChangeText={onChange}
              label={'Descrição da justificativa'}
            />
          )}
        />

        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ md: 6, xs: 12 }}>
            <ButtonComponent
              loading={
                isLoadingCreateSipClientReasonAsync ||
                isLoadingUpdateSipClientReasonAsync
              }
              fullWidth
              type="submit"
            >
              Salvar
            </ButtonComponent>
          </Grid2>

          <Grid2 size={{ md: 6, xs: 12 }}>
            <ButtonComponent
              type={'button'}
              color={'error'}
              fullWidth
              onClick={onCloseForm}
            >
              Cancelar
            </ButtonComponent>
          </Grid2>
        </Grid2>
      </form>
    </ModalComponent>
  );
};

export default ReasonEditionModal;
